import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BugReportButton } from '@unity-cosmos/chrome'
import App from './App.jsx'
import { ErrorBoundary } from './ErrorBoundary.jsx'
import './index.css'
import { markUnityEmbeddedFromUrl } from './lib/unityAuth.js'

markUnityEmbeddedFromUrl()

const rootElement = document.getElementById('root')
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
        <BugReportButton app="brainpower" lift />
      </ErrorBoundary>
    </StrictMode>,
  )
}
